import * as tslib_1 from "tslib";
export var FocusComponent;
(function (FocusComponent) {
    FocusComponent[FocusComponent["MailCompose"] = 0] = "MailCompose";
    FocusComponent[FocusComponent["MailList"] = 1] = "MailList";
    FocusComponent[FocusComponent["ReadingPane"] = 2] = "ReadingPane";
})(FocusComponent || (FocusComponent = {}));
var componentPriorityList = [
    FocusComponent.MailCompose,
    FocusComponent.MailList,
    FocusComponent.ReadingPane,
];
var registeredComponents = {};
/**
 * Register a component as available to be focused on
 */
export function registerComponent(component, setFocusCallback) {
    var componentKey = getFocusComponentKey(component);
    // There can be 2 reading panes when openening SxS
    if (registeredComponents[componentKey] && component !== FocusComponent.ReadingPane) {
        throw new Error('Component has already registered a focus manager callback');
    }
    registeredComponents[componentKey] = setFocusCallback;
}
/**
 * Unregister a component as no longer available to be focused on
 */
export function unregisterComponent(component) {
    registeredComponents[getFocusComponentKey(component)] = null;
}
/**
 * Determine which component should get focus and executes its callback to set focus
 * @returns promise that resolves when focus operation has been performed
 */
export function resetFocus() {
    return new Promise(function (resolve, reject) {
        window.requestAnimationFrame(function () {
            var e_1, _a;
            try {
                for (var componentPriorityList_1 = tslib_1.__values(componentPriorityList), componentPriorityList_1_1 = componentPriorityList_1.next(); !componentPriorityList_1_1.done; componentPriorityList_1_1 = componentPriorityList_1.next()) {
                    var component = componentPriorityList_1_1.value;
                    var setFocusCallback = registeredComponents[getFocusComponentKey(component)];
                    // When we find a registered component in the priority list,
                    // execute its set focus callback until focus() on the target element succeeds
                    if (setFocusCallback && setFocusCallback()) {
                        return resolve();
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (componentPriorityList_1_1 && !componentPriorityList_1_1.done && (_a = componentPriorityList_1.return)) _a.call(componentPriorityList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return resolve();
        });
    });
}
/**
 * Sets focus to the component
 */
export function setFocusTo(component) {
    var setFocusCallback = registeredComponents[getFocusComponentKey(component)];
    if (setFocusCallback) {
        setFocusCallback();
    }
}
function getFocusComponentKey(component) {
    return FocusComponent[component];
}
//# sourceMappingURL=mailModuleAutoFocusManager.js.map